import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { InputNumber } from "antd";

import axiosInst from "../../../../Config";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../../MiddleWare/EncryptDecrypt";
// import { SmallDatePickerStyle } from "./../../../Appointment/AddAppointment/StyledComponents";

const { Option } = Select;

const urgencyList = ["Low", "Medium", "High"];

const dosageOptions = [
  "n/a",
  "apply",
  "apply sparingly",
  "0.1",
  "0.25",
  "0.5",
  "1",
  "2",
  "3",
  "4",
  "1-2",
  "2-3",
  "2-4",
  "3-4",
  "5",
  "5-10",
  "6",
  "7",
  "8",
  "9",
  "10",
  "10-15",
  "15",
  "20",
  "10-20",
  "25",
  "30",
  "40",
  "50",
  "60",
  "70",
  "75",
  "80",
  "90",
  "100",
  "125",
  "150",
  "175",
  "200",
  "225",
  "250",
  "275",
  "300",
  "400",
  "500",
  "600",
  "750",
  "875",
  "1000",
];

const quantityOptions = [
  "10",
  "15",
  "20",
  "30",
  "45",
  "60",
  "90",
  "120",
  "180",
];

const RefillRequestPopup = ({ onClose, refreshData }) => {
  const [prescriptionDrugs, setPrescriptionDrugs] = useState([]);
  const [loadingDrugs, setLoadingDrugs] = useState(false);
  const [saving, setSaving] = useState(false);
const [searchText, setSearchText] = useState("");
  const [form, setForm] = useState({
    medicine_name: "",
    dosage: "",
    quantity: "",
    urgency: "",
    reason_for_request: "",
  });

  const [errors, setErrors] = useState({});

  const pid =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  /* ── fetch prescriptions to populate Medicine Name dropdown ── */
  useEffect(() => {
    if (!pid) return;
    setLoadingDrugs(true);
    const encrypted = Encrypt_Value({ pid }, "vozoportal");
    axiosInst
      .get("/vozoportal/patient/prescriptions", { params: { pid: pid } })
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozoportal");
        const list = Array.isArray(decrypted) ? decrypted : [];
        setPrescriptionDrugs(list);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingDrugs(false));
  }, [pid]);

  /* ── when a drug is selected from dropdown, auto-fill dosage & quantity ── */
  const handleDrugSelect = (value, option) => {
    const matched = prescriptionDrugs.find((d) => d.drug === value);
    console.log(matched, "0");
    setForm((prev) => ({
      ...prev,
      medicine_name: value,
      dosage: matched?.dosage || prev.dosage,
      quantity: matched?.dispense || prev.dispense,
    }));
    setErrors((prev) => ({ ...prev, medicine_name: false }));
  };

  /* ── when user types a custom name (not in list) ── */
  const handleDrugSearch = (value) => {
    setForm((prev) => ({ ...prev, medicine_name: value }));
  };

  const setField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  /* ── validation ── */
  const validate = () => {
    const e = {};
    if (!form.medicine_name.trim()) e.medicine_name = true;
    if (!form.dosage) e.dosage = true;
    if (!form.quantity) e.quantity = true;
    if (!form.urgency) e.urgency = true;
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ── submit ── */
  const handleSubmit = () => {
    if (!validate()) return;
    setSaving(true);

    const payload = Encrypt_Value(
      {
        pid,
        medicine_name: form.medicine_name,
        dosage: form.dosage,
        quantity: form.quantity,
        urgency: form.urgency,
        reason_for_request: form.reason_for_request,
      },
      "vozoportal",
    );

    axiosInst
      .post("/vozoportal/patient/updateRefillRequest", payload)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozoportal");
        // if (onSave) onSave(decrypted);
        onClose();
        refreshData();
      })
      .catch((err) => console.error(err))
      .finally(() => setSaving(false));
  };

  /* ── shared styles ── */
  const labelStyle = {
    fontSize: "13px",
    fontWeight: 500,
    marginBottom: "5px",
    color: "#1f2937",
  };

  const errorBorder = (field) =>
    errors[field] ? "1px solid #ef4444" : "1px solid #d1d5db";

  const selectStyle = { width: "100%" };

  return (
    <>
      {/* <SmallDatePickerStyle /> */}
      <div
        style={{
          width: "490px",
          maxHeight: "80vh",
          overflowY: "auto",
          scrollbarWidth: "thin",
          paddingRight: "6px",
        }}
      >
        {/* ── Header ── */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "14px",
          }}
        >
          <div style={{ fontSize: "17px", fontWeight: 600, color: "#111827" }}>
            New Refill Request
          </div>
          <div
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={onClose}
          >
            ✕
          </div>
        </div>

        {/* ── Medicine Name (searchable + auto-fill) ── */}
        <div style={{ marginBottom: "12px" }}>
          <div style={labelStyle}>
            Medicine Name <span style={{ color: "#ef4444" }}>*</span>
          </div>
          <Select
            showSearch
            allowClear
            size="middle"
            style={{
              ...selectStyle,
              ...(errors.medicine_name && {
                border: "1px solid #ef4444",
                borderRadius: "6px",
              }),
            }}
            placeholder="Select or type medicine name"
            loading={loadingDrugs}
            value={form.medicine_name || undefined}
            filterOption={(input, option) =>
              String(option?.children ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            onSearch={(val) => setSearchText(val)} // track typed text only
            onChange={(value) => {
              if (!value) {
                setField("medicine_name", "");
                setSearchText("");
                return;
              }
              // Selected from dropdown — auto-fill dosage & quantity
              const matched = prescriptionDrugs.find((d) => d.drug === value);
              console.log(matched,"match")
              if (matched) {
                setForm((prev) => ({
                  ...prev,
                  medicine_name: value,
                  dosage: matched.dosage || prev.dosage,
                  quantity: matched.quantity || prev.quantity,
                }));
                setErrors((prev) => ({ ...prev, medicine_name: false }));
                if(matched.dosage){
                setErrors((prev) => ({ ...prev,dosage:false }));
                }
                 if(matched.quantity){
                setErrors((prev) => ({ ...prev,quantity:false }));
                }
              } else {
                setField("medicine_name", value);
              }
              setSearchText("");
            }}
            onClear={() => {
              setField("medicine_name", "");
              setSearchText("");
            }}
            notFoundContent={
              searchText.trim() ? (
                <div
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    color: "#2C7BE5",
                    fontWeight: 500,
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault(); // keep dropdown open until we set state
                    setField("medicine_name", searchText.trim());
                    setSearchText("");
                  }}
                >
                  + Add &quot;{searchText}&quot; as custom medicine
                </div>
              ) : null
            }
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            {prescriptionDrugs.map((d) => (
              <Option key={d.id} value={d.drug}>
                {d.drug}
              </Option>
            ))}
          </Select>
          {errors.medicine_name && (
            <div style={{ color: "#ef4444", fontSize: "11px", marginTop: 3 }}>
              Required
            </div>
          )}
        </div>

        {/* ── Dosage + Quantity ── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "14px",
            marginBottom: "12px",
          }}
        >
          {/* Dosage */}
          <div>
            <div style={labelStyle}>
              Dosage <span style={{ color: "#ef4444" }}>*</span>
            </div>
            <Select
              showSearch
              allowClear
              size="middle"
              style={selectStyle}
              placeholder="Select or type dosage"
              value={form.dosage || undefined}
              filterOption={(input, option) =>
                String(option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onSelect={(val) => setField("dosage", val)}
              onSearch={(val) => setField("dosage", val)}
              onClear={() => setField("dosage", "")}
              getPopupContainer={(trigger) => trigger.parentNode}
              status={errors.dosage ? "error" : ""}
            >
              {dosageOptions.map((d) => (
                <Option key={d} value={d}>
                  {d}
                </Option>
              ))}
            </Select>
            {errors.dosage && (
              <div style={{ color: "#ef4444", fontSize: "11px", marginTop: 3 }}>
                Required
              </div>
            )}
          </div>

          {/* Quantity */}
          <div>
            <div style={labelStyle}>
              Quantity <span style={{ color: "#ef4444" }}>*</span>
            </div>
           <InputNumber
  style={{ width: "100%", ...selectStyle }}
  placeholder="Enter quantity"
  value={form.quantity || null}
  min={1}
  onChange={(val) => setField("quantity", val)}
  onBlur={() => {
    if (!form.quantity) setField("quantity", "");
  }}
  status={errors.quantity ? "error" : ""}
/>
            {errors.quantity && (
              <div style={{ color: "#ef4444", fontSize: "11px", marginTop: 3 }}>
                Required
              </div>
            )}
          </div>
        </div>

        {/* ── Urgency ── */}
        <div style={{ marginBottom: "12px" }}>
          <div style={labelStyle}>
            Urgency <span style={{ color: "#ef4444" }}>*</span>
          </div>
          <Select
            size="middle"
            style={selectStyle}
            placeholder="Select urgency"
            value={form.urgency || undefined}
            onChange={(val) => setField("urgency", val)}
            getPopupContainer={(trigger) => trigger.parentNode}
            status={errors.urgency ? "error" : ""}
          >
            {urgencyList.map((u) => (
              <Option key={u} value={u}>
                {u}
              </Option>
            ))}
          </Select>
          {errors.urgency && (
            <div style={{ color: "#ef4444", fontSize: "11px", marginTop: 3 }}>
              Required
            </div>
          )}
        </div>

        {/* ── Reason ── */}
        <div style={{ marginBottom: "18px" }}>
          <div style={labelStyle}>Reason for Request</div>
          <textarea
            style={{
              width: "100%",
              minHeight: "70px",
              maxHeight: "120px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "10px",
              fontSize: "14px",
              resize: "vertical",
              outline: "none",
              boxSizing: "border-box",
            }}
            placeholder="Enter reason (optional)"
            value={form.reason_for_request}
            onChange={(e) => setField("reason_for_request", e.target.value)}
          />
        </div>

        {/* ── Footer ── */}
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            onClick={onClose}
            style={{
              border: "1px solid #2C7BE5",
              background: "#fff",
              color: "#2C7BE5",
              padding: "6px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Cancel
          </button>

          <button
            disabled={saving}
            onClick={handleSubmit}
            style={{
              background: saving ? "#93c5fd" : "#2C7BE5",
              color: "#fff",
              padding: "6px 18px",
              borderRadius: "6px",
              border: "none",
              cursor: saving ? "not-allowed" : "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            {saving ? "Saving..." : "Submit Request"}
          </button>
        </div>
      </div>
    </>
  );
};

export default RefillRequestPopup;
